import { getCompanyInfo } from "@/api/home";
import { defineStore } from "pinia";
import type { CompanyInfo } from "@/api/types";
interface WebState {
  companyInfo: CompanyInfo;
  bannerHeight: number;
}

export const useWebStore = defineStore("web", {
  state: (): WebState => ({
    companyInfo: {},
    bannerHeight: 640,
  }),
  getters: {
    getCompanyInfo(): CompanyInfo {
      return this.companyInfo;
    },
    getBannerHeight(): number {
      return this.bannerHeight;
    },
  },
  actions: {
    async setCompanyInfo() {
      let { code, data } = await getCompanyInfo();
      if (code === 200) {
        this.companyInfo = data;
        this.companyInfo.historys = JSON.parse(data.history!);
      }
    },
    setBannerHeight(height: number) {
      this.bannerHeight = height;
    },
  },
});
